// Utility functions for persisting quote form data during authentication flow

const QUOTE_STORAGE_KEY = 'twerce_quote_draft';
const QUOTE_EXPIRY_HOURS = 24; // Quote drafts expire after 24 hours

export const saveQuoteDraft = (quoteData) => {
  try {
    const draft = {
      ...quoteData,
      timestamp: Date.now(),
      expiresAt: Date.now() + (QUOTE_EXPIRY_HOURS * 60 * 60 * 1000)
    };
    
    localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(draft));
    return true;
  } catch (error) {
    console.error('Error saving quote draft:', error);
    return false;
  }
};

export const getQuoteDraft = () => {
  try {
    const draft = localStorage.getItem(QUOTE_STORAGE_KEY);
    if (!draft) return null;
    
    const parsedDraft = JSON.parse(draft);
    
    // Check if draft has expired
    if (parsedDraft.expiresAt && Date.now() > parsedDraft.expiresAt) {
      localStorage.removeItem(QUOTE_STORAGE_KEY);
      return null;
    }
    
    return parsedDraft;
  } catch (error) {
    console.error('Error retrieving quote draft:', error);
    return null;
  }
};

export const clearQuoteDraft = () => {
  try {
    localStorage.removeItem(QUOTE_STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing quote draft:', error);
    return false;
  }
};

export const updateQuoteDraft = (updates) => {
  try {
    const existingDraft = getQuoteDraft();
    if (!existingDraft) return false;
    
    const updatedDraft = {
      ...existingDraft,
      ...updates,
      timestamp: Date.now(),
      expiresAt: Date.now() + (QUOTE_EXPIRY_HOURS * 60 * 60 * 1000)
    };
    
    localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(updatedDraft));
    return true;
  } catch (error) {
    console.error('Error updating quote draft:', error);
    return false;
  }
};

// Check if there's a pending quote submission
export const hasPendingQuote = () => {
  return getQuoteDraft() !== null;
};

// Get the RFQ ID from the pending quote
export const getPendingQuoteRFQId = () => {
  const draft = getQuoteDraft();
  return draft?.rfqId || null;
}; 